/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbRespCollectionsComponents_collectionsModules$ref = any;
type SbRespCollectionsComponents_searchBrowse$ref = any;
type SbRespCreatorSpotlightModule_collectionsModules$ref = any;
type SbSharedCollectionsModulesHeroModule_collectionsModules$ref = any;
type SharedProductCarousel_collectionsModules$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespCollectionsModules_searchBrowse$ref: FragmentReference;
export type SbRespCollectionsModules_searchBrowse = {|
  +collectionsModules: ?$ReadOnlyArray<?{|
    +moduleType: ?string,
    +id: ?string,
    +$fragmentRefs: SbSharedCollectionsModulesHeroModule_collectionsModules$ref & SharedProductCarousel_collectionsModules$ref & SbRespCollectionsComponents_collectionsModules$ref & SbRespCreatorSpotlightModule_collectionsModules$ref,
  |}>,
  +$fragmentRefs: SbRespCollectionsComponents_searchBrowse$ref,
  +$refType: SbRespCollectionsModules_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespCollectionsModules_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "contentModuleId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespCollectionsComponents_searchBrowse",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "collectionsModules",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "previewId",
          "variableName": "contentModuleId",
          "type": "String"
        }
      ],
      "concreteType": null,
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "moduleType",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbSharedCollectionsModulesHeroModule_collectionsModules",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SharedProductCarousel_collectionsModules",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbRespCollectionsComponents_collectionsModules",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbRespCreatorSpotlightModule_collectionsModules",
          "args": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '62ae17bfbcdd983077a592deab0984d8';
module.exports = node;
